<div class="margin" [formGroup]="form">
  <mat-form-field class="width100Full" [appearance]="appearance">
    <mat-label>{{item.label}}</mat-label>
    <mat-icon matPrefix class="classInfo">search</mat-icon>
    <mat-icon *ngIf="isEnhanced" matSuffix class="classInfo text-red-600 cursor-pointer" (click)="clear()">clear
    </mat-icon>
    <div class="input">

      <input matInput aria-label="State" [matAutocomplete]="auto" [formControl]="stateCtrl"
        [required]="stateCtrl.errors?.['required']">


      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let element of groups " [value]="element[item.viewValueSelect!]"
          (onSelectionChange)="updateMySelection(element, element[item.viewValueSelect!])">
          <div class="row">
            <div>{{element[item.viewValueSelect!]}}</div>
          </div>
        </mat-option>
      </mat-autocomplete>
      <mat-icon *ngIf="item.info" class="classInfo" [matTooltip]="item.info">info</mat-icon>
    </div>
    <mat-error *ngIf="stateCtrl.hasError('required')">{{utils.traslatei18n('requiredField')}}</mat-error>
  </mat-form-field>
</div>